/*
* Global app configuration.
*
* USE: this.$conf.ROLES
*/
import { DRAWER_TYPES } from '@/constants/drawer.js';
import { ROLES, ROLES_NAMES } from '@/constants/roles';
import { PERMISSIONS, PERMISSIONS_NAMES } from '@/constants/permissions';
import { LEVEL_TYPES, LEVEL_NAMES, LEVEL_TYPES_LIST } from '@/constants/level';
import { REPORT_TYPES, REPORT_TYPES_DATA, REPORT_TYPES_LIST } from '@/constants/reports';
import * as eventsConstants from '@/modules/Events/constants.js';
import * as teamConstants from '@/modules/Team/constants.js';
import * as moderationConstants from '@/modules/Moderation/constants.js';

const authenticatedInstructions = new Map();
authenticatedInstructions.set([ROLES.department], 'Departament');
authenticatedInstructions.set([ROLES.member, ROLES.certificate], 'Member');
authenticatedInstructions.set([ROLES.operator], 'Operator');
authenticatedInstructions.set([ROLES.organization], 'Organization');

export const HEADER_KEY_TOTAL = 'x-pagination-total-count';
export const HEADER_KEY_PAGE = 'x-pagination-current-page';
export const HEADER_KEY_PAGES = 'x-pagination-page-count';
export const HEADER_KEY_PER_PAGE = 'x-pagination-per-page';

export default {
  PRIVACY_POLICY: '/agreements/policy',
  USER_AGREEMENT: '/agreements/user-agreement',

  APPLICATION_IOS: 'https://apps.apple.com/us/app/афиша-мероприятий/id1629014808',
  APPLICATION_ANDROID: 'https://www.rustore.ru/catalog/app/com.irpsu.events',

  authenticatedInstructions,

  ...eventsConstants,
  ...teamConstants,
  ...moderationConstants,

  DRAWER_TYPES,
  ROLES,
  ROLES_NAMES,

  PERMISSIONS,
  PERMISSIONS_NAMES,

  LEVEL_TYPES,
  LEVEL_NAMES,
  LEVEL_TYPES_LIST,

  REPORT_TYPES,
  REPORT_TYPES_DATA,
  REPORT_TYPES_LIST,

  HEADER_KEY_TOTAL,
  HEADER_KEY_PAGE,
  HEADER_KEY_PAGES,
  HEADER_KEY_PER_PAGE,
};
